import { Navigate } from 'react-router';
import { SEND_A_CITYSPRINT_PARCEL } from '../../../constants/routes';

const SendCitysprintParcelSummary = () => (
  <Navigate to={SEND_A_CITYSPRINT_PARCEL} replace />
);

export default SendCitysprintParcelSummary;
